import { render, staticRenderFns } from "./TourneyList.vue?vue&type=template&id=2d0eb326&"
import script from "./TourneyList.vue?vue&type=script&lang=ts&"
export * from "./TourneyList.vue?vue&type=script&lang=ts&"
import style0 from "./TourneyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports